<template>
  <input
    :value="localKeyword"
    @input="updateKeyword"
    type="text"
    class="flex-shrink md:w-10/12 w-full h-[48px] outline-1 focus:outline outline-primary focus:border-0 px-4 py-2 bg-gray-100 rounded-xl border border-gray-100 text-base placeholder:tracking-wide placeholder:font-light text-gray-600"
    placeholder="City, Community, or Building"
  />
</template>

<script>
export default {
  props: {
    keyword: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      localKeyword: this.keyword,
    };
  },
  watch: {
    keyword(newValue) {
      this.localKeyword = newValue;
    },
  },
  methods: {
    updateKeyword(event) {
      this.localKeyword = event.target.value;
      this.$emit("update:keyword", this.localKeyword);
    },
  },
};
</script>
